export default (datum, capability) => {
    try {
        const variable = Object.keys(capability.variables)[0];
        const value = datum[variable];
        if (value === undefined || value === null) {
            return false;
        } else {
            return true;
        }
    } catch (e) {
        return false;
    }
};
